"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PhoneInputConsent = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _ = require("..");
var _mobile = require("../../utils/mobile.utils");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var PhoneInputConsent = function PhoneInputConsent(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/_react.default.createElement(_.Tooltip, {
    overlayClassName: "max-w-[250px]",
    placement: "top",
    trigger: (0, _mobile.isMobileOrTablet)() ? 'click' : 'hover',
    title: /*#__PURE__*/_react.default.createElement("p", {
      className: "tw-caption-medium text-grey-75 m-0"
    }, "Your phone number will be used for transactional notifications related to your treatment like appointment reminders and insurance eligibility.")
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('cursor-pointer flex justify-center items-end pr-[12px]', className)
  }, /*#__PURE__*/_react.default.createElement(_.Icon, {
    type: "info",
    size: 16
  })));
};
exports.PhoneInputConsent = PhoneInputConsent;